import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress} from '@mui/material';
// import StarBorderIcon from '@mui/icons-material/StarBorder';
import SubmitCredentials  from './SubmitCreds';
import useEmailVerification  from './hooks/useEmailVerification'; 
import EnableAccount from './EnableAccount';
// import { post_auth } from './auth';
import { useConfig } from './ConfigHolder';
import { useAuth } from './AuthProvider';
import { useNavigate, useLocation} from 'react-router-dom';
import {ErrorCatcher} from './components/ErrorCatcher';
import FirstTimeLangSelection from './FirstTimeLangSelection';
import Header from './Header';
import Footer from './Footer';
// import { SelectionRow } from './FirstTimeLangSelection';
// import { configKeys } from './ConfigHolder';
// import { ShowChart } from '@mui/icons-material';


const SignUp = () => {
    // const [registerSuccess, setRegisterSuccess] = useState(false);
		const [triggerPolling, setTriggerPolling] = useState(false);
		const { logout } = useAuth();
		// const [error, setError] = useState(null);
		const { isVerified, verifying, verificationError } = useEmailVerification(triggerPolling, 5000, 60, logout);
		const [showLangSelection, setShowLangSelection] = useState(false);
		const [waitingForUserEmailVerification, setWaitingForUserEmailVerification] = useState(false);
		// const [emailVerified, setEmailVerified] = useState(false);
		const [email, setEmail] = useState(null);
		// const [pw, setPw] = useState(null);
		const navigate = useNavigate();
		const location = useLocation();
		const {getConfigCloud} = useConfig();
		const [trialSuccess, setTrialSuccess] = useState(false);
		const [configError, setConfigError] = useState(null);
		let passEmail = '';
		let passPassword = '';
	  
		// Check if location and location.state are defined
		if (location && location.state) {
		  // Now conditionally assign values if they exist
		  if (location.state.passEmail) {
			passEmail = location.state.passEmail;
		  }
		  if (location.state.passPassword) {
			passPassword = location.state.passPassword;
		  }
		};

    
		useEffect( () => {
			setWaitingForUserEmailVerification(false);
			
			// const fetchConfig = async () => {
			// 	const res = await getConfigCloud();
			// 	setShowLangSelection(true);
			// }
			
			try {
			if (isVerified) {
				// fetchConfig();
				setTriggerPolling(false);
			} else {
				setWaitingForUserEmailVerification(false);	
				if (verificationError) {
					setWaitingForUserEmailVerification(false);	
				}
				if (! verifying && ! verificationError) {
					logout();
					setWaitingForUserEmailVerification(false);
					navigate('/login');					
				}
			}

		} catch (error) {
			console.error(error);
		}
		// eslint-disable-next-line
		}, [isVerified, verifying, verificationError])


		const onSubmitCredentialsSuccess = (creds) => {
			// Note: failure situations are addressed within the SubmitCredentials component
        		// setRegisterSuccess(true);
				setTriggerPolling(true);
				setWaitingForUserEmailVerification(true);
				setEmail(creds.email);
				// setPw(creds.password)
    	}

		const onEnableAccountSuccess = () => {
			const fetchConfig = async () => {
			  try {
				// eslint-disable-next-line
				const res = await getConfigCloud();
				setTrialSuccess(true);  // This assumes that the trial success state should be independent of the config fetch success
				setShowLangSelection(true);  // Set this state only after config is successfully fetched
			  } catch (error) {
				console.error("Failed to fetch configuration:", error);
				setConfigError(error);				
			  }
			}
		  
			fetchConfig();
		  }

		// const handleOnClickSecurePayment = async () => {
		// 	const MONTHLY_PAYMENT = 5.0;
		// 	const route_success = 'psuccess';
		// 	const route_cancel = 'pcancel';

		// 	const data = {'payment_total':MONTHLY_PAYMENT, 'route_success':route_success, 'route_cancel':route_cancel};
		// 	const uri = `${serverUrl}/create_paypal_payment`;

		// 	try {
		// 		const res = await post_auth(uri, data);
		// 		if (res.data.approval_url) {
		// 			window.location.href = res.data.approval_url;
		// 		}
		// 		console.log(res);
		// 	} catch {
		// 		console.log("Could not get paypay url");
		// 	}
		// }

    return (
        <Box>
			<Header></Header>
			{verificationError && (<ErrorCatcher error = {verificationError}></ErrorCatcher>)}
			{configError && (<ErrorCatcher error = {configError}></ErrorCatcher>)}
			{ (! isVerified ) &&
				<SubmitCredentials
  					onSuccess={onSubmitCredentialsSuccess}
  					embedded
  					email={passEmail}
  					password={passPassword}
				/>

			}

			{ (waitingForUserEmailVerification) ? 
				<Box>
					<CircularProgress sx = {{ml:3, mb:1}}></CircularProgress>
					<Typography sx = {{ml:3}}>Waiting for the confirmation results for {email}... </Typography> 
				</Box> 
			: null
			}

			{ isVerified && ( 
				<EnableAccount email = {email}
					   onEnableAccountSuccess={onEnableAccountSuccess}
				> </EnableAccount>
			) }

			{ trialSuccess && 
			(
			<FirstTimeLangSelection open = {showLangSelection}
									onClose = {()=>{setShowLangSelection(false);
										navigate('/main')
									}} 
			>
			</FirstTimeLangSelection> 
			)
			}
			<Footer/>
        </Box>
    );
};

export default SignUp;